import script from "./PasswordExpirationNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordExpirationNotification.vue?vue&type=script&setup=true&lang=js"

import "./PasswordExpirationNotification.vue?vue&type=style&index=0&id=e3bf834a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3bf834a"]])

export default __exports__